<template>
  <div>
    <div style="padding-top: 0.1em; padding-bottom: 0.1rem" :class="'mr-1 text-xs px-3 rounded ' + correctClass">
      {{ correctText }}
    </div>
  </div>
</template>
<script>
export default{
  props: {
    value: Boolean,
  },
  computed: {
    correctText(){
      return (this.value) ? this.$t('global.yes') : this.$t('global.no')
    },
    correctClass(){
      return (this.value) ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'
    }
  }
}
</script>
